import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { TRANSFORMATIONS } from '../../data/mock';
import { img, srcSet } from '../../lib/img';
import { Button } from '../ui/button';

export default function TransformationsPreview() {
  const featured = TRANSFORMATIONS.slice(0, 3);
  return (
    <section className="py-24 lg:py-32 bg-ivory-warm">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14 reveal">
          <div className="max-w-2xl">
            <p className="text-[11px] tracking-[0.3em] uppercase text-champagne-deep mb-6">Client Transformations</p>
            <h2 className="font-serif text-4xl lg:text-6xl leading-[1.05] text-charcoal">
              The work, <em className="italic-accent">not the faces.</em>
            </h2>
            <p className="mt-6 text-charcoal/70 leading-relaxed max-w-xl">
              Every engagement is private. Identities are kept confidential — the transformation is shared in outcomes, not in names.
            </p>
          </div>
          <Link to="/client-transformations" data-testid="transformations-see-all">
            <Button variant="outline" className="border-charcoal text-charcoal hover:bg-charcoal hover:text-ivory rounded-none px-7 py-6 text-[11px] tracking-[0.22em] uppercase">
              View All Transformations <ArrowRight size={14} className="ml-2" />
            </Button>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 reveal">
          {featured.map((t) => (
            <Link
              key={t.id}
              to="/client-transformations"
              className="group block bg-ivory border border-ivory-deep overflow-hidden"
              data-testid={`transformation-card-${t.id}`}
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-ivory-warm">
                <img
                  loading="lazy"
                  decoding="async"
                  src={img(t.composite, 1400)}
                  srcSet={srcSet(t.composite, [600, 1000, 1400])}
                  sizes="(max-width: 768px) 100vw, 30vw"
                  alt="Client transformation — before and after styling by Mondaine Style"
                  className="absolute inset-0 w-full h-full object-contain p-3"
                />
                <span className="absolute top-3 right-3 text-[9px] tracking-[0.3em] uppercase text-charcoal bg-champagne/95 px-2 py-1">Before · After</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
